var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNavChevronright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#660099"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.742 42.75c-.3 0-.6-.114-.832-.34L21.73 29.466c-.226-.222-.354-.525-.355-.842-.001-.317.124-.621.348-.845l13.18-13.18c.464-.465 1.215-.465 1.679 0 .464.464.464 1.214 0 1.678L24.249 28.611l12.326 12.104c.468.46.475 1.212.014 1.68-.231.236-.539.355-.847.355",
    transform: "translate(-1223 -330) translate(1223 330) matrix(-1 0 0 1 58.305 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNavChevronright);
export default __webpack_public_path__ + "static/media/ic-nav-chevronright.6a7e53a026e730c9358f363176e7ffde.svg";
export { ForwardRef as ReactComponent };